import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-442fd6b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "¡Bienvenido a nuestra sección de BootCamps!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "¿Listo para impulsar tu carrera ?", -1))
const _hoisted_7 = { class: "cards" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Acceder", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import BootCampService from '@/services/BootCampService';
import BootCampsI from '@/interfaces/BootCampInterface';
import { onMounted,ref,Ref } from 'vue';
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'BootCampsView',
  setup(__props) {

const loading:Ref<boolean> = ref(false)
const service = new BootCampService
const bootcamps:Ref<BootCampsI[]> = ref([])

onMounted(async()=>{
  loading.value = true;
  bootcamps.value = await service.GetBootCamp()
  loading.value = false;
  
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("p", null, [
          _createTextVNode(" Aquí tienes acceso a los bootcamps exclusivos de " + _toDisplayString(_unref(main).NAME_COMPANY_FOOTER), 1),
          _hoisted_5,
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bootcamps.value, (elm) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card",
              key: elm?.id
            }, [
              _createElementVNode("a", {
                href: `/bootcamp-visor/${elm?.id}`
              }, [
                _createElementVNode("img", {
                  src: elm?.image_url,
                  alt: "img"
                }, null, 8, _hoisted_9),
                _createElementVNode("h4", null, _toDisplayString(elm?.title), 1),
                _createElementVNode("h4", null, _toDisplayString(elm?.subtitle), 1),
                _hoisted_10
              ], 8, _hoisted_8)
            ]))
          }), 128)),
          _hoisted_11,
          _hoisted_12
        ])
      ])
    ]),
    _: 1
  }))
}
}

})